document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.USP_carousel_bar_swiper');
  if (!container) return;

  let swiper = null;

  function initUSPSwiper() {
    if (typeof Swiper !== 'undefined') {
      swiper = new Swiper('.USP_carousel_bar_swiper', {
        slidesPerView: 'auto',
        speed: 6000,
        allowTouchMove: false,
        loopAdditionalSlides: 1,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
        spaceBetween: 24,
        breakpoints: {
          800: {
            spaceBetween: 40,
            speed: 8000,
          },
        },
        loop: true,
        observer: true,
        observeParents: true,
      });

      // Force autoplay start after initialization (Android fix)
      if (swiper && swiper.autoplay) {
        swiper.autoplay.start();
      }

      // Android fix: restart autoplay when page becomes visible again
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible' && swiper && swiper.autoplay) {
          swiper.autoplay.start();
        }
      });

      // Android fix: restart autoplay after any touch interaction
      container.addEventListener('touchend', () => {
        if (swiper && swiper.autoplay) {
          setTimeout(() => swiper.autoplay.start(), 100);
        }
      });
    } else {
      setTimeout(initUSPSwiper, 100);
    }
  }

  initUSPSwiper();
});